/**
 * Утилиты форматирования для компонентов событий
 */
import type { EventQueueStatus } from '../../../types/plantingEvents';

/**
 * Конфигурация статусов событий
 */
export const EVENT_STATUS_CONFIG: Record<
  EventQueueStatus,
  { color: string; text: string }
> = {
  planned: { color: 'default', text: 'Запланировано' },
  pending: { color: 'orange', text: 'Ожидает' },
  in_progress: { color: 'blue', text: 'Выполняется' },
  completed: { color: 'green', text: 'Завершено' },
  cancelled: { color: 'red', text: 'Отменено' },
};

/**
 * Форматирует дату в локальный формат
 */
export const formatEventDate = (date: string | null | undefined): string => {
  if (!date) return '—';
  try {
    return new Date(date).toLocaleDateString('ru-RU');
  } catch {
    return '—';
  }
};

/**
 * Форматирует дату и время
 */
export const formatEventDateTime = (date: string | null | undefined): string => {
  if (!date) return '—';
  try {
    return new Date(date).toLocaleString('ru-RU');
  } catch {
    return '—';
  }
};

/**
 * Вычисляет прогресс в процентах
 */
export const calculateProgress = (completed: number, total: number): number => {
  if (total === 0) return 0;
  return Math.round((completed / total) * 100);
};
